import { render, staticRenderFns } from "./RegistrationCourt.vue?vue&type=template&id=e2ddcdc4&"
import script from "./RegistrationCourt.vue?vue&type=script&lang=ts&"
export * from "./RegistrationCourt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports